module.exports = __webpack_public_path__ + "static/20-b0bfc30d45af5c4d3cf611cad67aafca.png";